import { IconButton, useColorModeValue } from '@chakra-ui/react'
import { X } from 'lucide-react'
import React from 'react'
import { PiSidebar } from 'react-icons/pi'
import useMobile from '../../hooks/utility/useMobile'

interface SidebarToggleButtonProps {
  isOpen: boolean
  onToggle?: () => void
  isFloating?: boolean
}

const SidebarToggleButton: React.FC<SidebarToggleButtonProps> = ({
  isOpen,
  onToggle,
  isFloating = false
}) => {
  const isMobile = useMobile()
  const toggleBg = useColorModeValue('white', 'transparent')

  return (
    <IconButton
      aria-label={isOpen ? 'Close sidebar' : 'Open sidebar'}
      icon={(isMobile && isOpen) ? <X size={18} /> : <PiSidebar size={18} />}
      onClick={onToggle || (() => undefined)}
      position={isFloating ? 'fixed' : 'absolute'}
      top={3}
      left={3}
      variant='unstyled'
      color='gray.500'
      zIndex={isFloating ? 1001 : 10}
      minW='32px'
      h='32px'
      bg={isFloating ? toggleBg : 'transparent'}
      borderRadius='md'
      p={2}
      display='flex'
      alignItems='center'
      justifyContent='center'
      _hover={{
        color: 'gray.700'
      }}
      _active={{
        color: 'gray.800'
      }}
    />
  )
}

export default SidebarToggleButton
